module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUAgMAAADnxWVXAAAACVBMVEUAlGDOESb80RaADeWBAAAAE0lEQVQI12MIDY1atYoBCIYOAwCuyC7hcLeFEAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/gn.png
// module id = 289
// module chunks = 0